module.exports = __webpack_public_path__ + "static/media/icon-alerts.5f383ca3.svg";